// extracted by mini-css-extract-plugin
export default {"base":"styles__base--Lqlf1","horizontal-padding":"styles__horizontal-padding--mUZzf","small":"styles__small--69Snr","medium":"styles__medium--5AIfz","large":"styles__large--Dxz5X"};